import { type CreateContactAndUpdateOrderRequest } from '@wix/cashier-core/dist/src/services/Order/types';
import { type UserInfo } from '../types/UserInfo';

export const transformCountryKeyToApiFormat = (address: UserInfo): CreateContactAndUpdateOrderRequest['buyerInfo'] => {
  const { country, ...otherAddress } = address;

  return {
    ...otherAddress,
    countryCode: country,
  };
};
